<template>
    <v-page-content>
      <v-content-info-page></v-content-info-page>
    </v-page-content>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { types } from '@/config/content/types'

export default {
  name: 'SelectedPartner',
  data() {
    return {
      selectedId: null
    }
  },
  created() {
    this.selectedId = this.$route.params.gpUniver
    this.getData()
  },
  beforeRouteUpdate(to, from, next) {
    this.selectedId = to.params.gpUniver
    this.getData()
    next()
  },
  methods: {
    ...mapActions({
      fetchPartner: 'content/fetchSelectedPartner'
    }),
    ...mapMutations({
      setContentType: 'content/setContentType'
    }),
    getData() {
      this.fetchPartner(this.selectedId).then((data) => {
        if (data) {
          this.$router.push('/page_not_exist')
        } else {
          this.setContentType(types.partner)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
